export function error(code, message, key, data = {}) {
  return { error: { code, message, key }, ...data }
}

export function success(message, key, data = {}) {
  return { error: null, message, key, ...data }
}